export default {
  title: {
    id: 'address_book_rules_activity_title',
    defaultMessage: 'Select one activity',
  },
  cta: {
    id: 'address_book_rules_cta',
    defaultMessage: 'Save and continue',
  },
  productReturn: {
    id: 'address_book_rules_activity_product_return',
    defaultMessage: 'Product Return',
  },
  productRefund: {
    id: 'address_book_rules_activity_product_refund',
    defaultMessage: 'Product Refund',
  },
  productRepair: {
    id: 'address_book_rules_activity_product_repair',
    defaultMessage: 'Product Repair',
  },
  buyback: {
    id: 'address_book_rules_activity_buyback',
    defaultMessage: 'BuyBack',
  },
  backship: {
    id: 'address_book_rules_activity_backship',
    defaultMessage: 'BackShip',
  },
}
